import { Navigate, useParams } from 'react-router-dom';

/* Legacy /profile/:nickname redirects to new /u/:nickname public page */
export default function ProfilePage() {
    const { nickname } = useParams();
    return <Navigate to={`/u/${nickname}`} replace />;
}
